/**
 * Home / fiókbeállítások oldal szövegei
 *
 * Namespace: home
 */
export const home = {
  // Oldal
  page: {
    title: "Fiókbeállítások",
    subtitle: "Kezeld a fiókodhoz tartozó adatokat",
  },

  // Profil szekció
  profile: {
    sectionTitle: "Fiók adatai",
    email: "Email cím",
    name: "Név",
    unknownName: "Ismeretlen felhasználó",
  },

  // Jelszócsere szekció
  changePassword: {
    sectionTitle: "Jelszó módosítása",
    currentPasswordLabel: "Jelenlegi jelszó",
    currentPasswordPlaceholder: "••••••••",
    newPasswordLabel: "Új jelszó",
    newPasswordPlaceholder: "••••••••",
    newPasswordHelperText: "Legalább 8 karakter",
    confirmPasswordLabel: "Új jelszó megerősítése",
    confirmPasswordPlaceholder: "••••••••",
    submitButton: "Jelszó mentése",
    loadingButton: "Mentés...",

    success: {
      title: "Jelszó megváltoztatva",
      message: "Az új jelszavad sikeresen mentve.",
    },

    errors: {
      invalidCurrentPassword: "A megadott jelenlegi jelszó helytelen.",
      sameAsCurrentPassword: "Az új jelszó nem egyezhet meg a jelenlegivel.",
      changeFailed: "A jelszó módosítása sikertelen. Kérjük, próbáld újra.",
    },
  },

  // Kijelentkezés szekció
  logout: {
    sectionTitle: "Kijelentkezés",
    description: "Bezárja az aktuális munkamenetet.",
    logoutButton: "Kijelentkezés",
    loadingButton: "Kijelentkezés...",
    confirmQuestion: "Biztosan ki szeretnél lépni?",
    confirmDescription: "Az aktuális munkameneted megszűnik.",
    confirmYes: "Igen, kilépek",
    confirmNo: "Mégse",
  },
} as const;

export type HomeMessages = typeof home;
